// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const SUPABASE_URL = "https://rrmhxzaxghiovfqqggfv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJybWh4emF4Z2hpb3ZmcXFnZ2Z2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE0NDU3NTEsImV4cCI6MjA1NzAyMTc1MX0.yckUWhupNFQf3pEXoDtz0NFK4BmRhuBga2GCAAKlrDg";

// Custom storage adapter that handles SSR
const createCustomStorage = () => {
  // Return a dummy storage object for server-side rendering
  if (typeof window === "undefined") {
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    };
  }

  // Return localStorage for client-side
  return localStorage;
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      storage: createCustomStorage(),
      storageKey: "SUPABASE_SESSION",
    },
  }
);
